import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, Spin } from 'antd'
import MyIcon from '../../../../components/general/icon'
import AddRecipeIngredient from './add'
import EditRecipeIngredient from './edit'
import DeleteRecipeIngredient from './delete'

const RecipeIngredient = (props) => {
  const { oid, name } = props.data
  const [propsData, setPropsData] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [recipeIngredientData, setRecipeIngredientData] = useState([])
  const [isAddRecipeIngredientVisible, setIsAddRecipeIngredientVisible] = useState(false)
  const [isEditRecipeIngredientVisible, setIsEditRecipeIngredientVisible] = useState(false)
  const [isDeleteRecipeIngredientVisible, setIsDeleteRecipeIngredientVisible] = useState(false)

  const getRecipeIngredientData = () => {
    axios.post('/admin/user/recipe_ingredient/get', { 
      recipe_oid: oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setRecipeIngredientData(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getRecipeIngredientData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oid])

  const handleCancel = () => {
    props.isCancel()
    props.getExerciseRecipeData()
  }

  const addRecipeIngredient = () => {
    setIsAddRecipeIngredientVisible(true)
    setPropsData({ recipeOid: oid})
  }

  const editRecipeIngredient = (item) => {
    setIsEditRecipeIngredientVisible(true)
    setPropsData({ item: item})
  }

  const deleteRecipeIngredient = (oid, name) => {
    setIsDeleteRecipeIngredientVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  return (
    <>
      <Modal 
        title={name}
        destroyOnClose={true}
        width='600px'
        open={props.isOpen}
        onCancel={handleCancel}
        footer={false}>

        <Spin spinning={isLoading}>
          <div className='public-filter' style={{marginBottom: '-20px'}}>
            <div className='public-datail-button' onClick={() => { addRecipeIngredient() }}>添加食材</div>
          </div>

          <div className='public-main-style2'>
            <table className='public-main-style2-item'>
              <thead>
                <tr className='public-main-style2-thead'>
                  <th><div className='public-main-style2-title'>食材名称</div></th>
                  <th>用量(g)</th>
                  <th>排序</th>
                  <th style={{width: '50px'}}></th>
                </tr>
              </thead>

              <tbody>
                {recipeIngredientData && (recipeIngredientData.length > 0 ? (recipeIngredientData.map((item) => (
                  <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { editRecipeIngredient(item) }}>
                    <td><div className='public-main-style2-title'>{item.ingredient_name}</div></td>
                    <td>{item.dosage}</td>
                    <td>{item.sort}</td>
                    <td style={{width: '50px'}}>
                      <div className='public-main-style2-operation-box'>
                        <div className='public-main-style2-operation' 
                          onClick={(event) => {event.stopPropagation(); deleteRecipeIngredient(item.oid, item.ingredient)}}>
                          <MyIcon name='huishouzhan' />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))) : (
                  <tr className='public-main-style2-tbodyEmpty'>
                    <td colSpan="4"><span>暂无数据</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Spin>

        {isAddRecipeIngredientVisible && <AddRecipeIngredient
          data={propsData}
          isOpen={isAddRecipeIngredientVisible} 
          isCancel={() => { setIsAddRecipeIngredientVisible(false) }} 
          getRecipeIngredientData={getRecipeIngredientData} 
        />}
        {isEditRecipeIngredientVisible && <EditRecipeIngredient
          data={propsData}
          isOpen={isEditRecipeIngredientVisible} 
          isCancel={() => { setIsEditRecipeIngredientVisible(false) }} 
          getRecipeIngredientData={getRecipeIngredientData} 
        />}
        {isDeleteRecipeIngredientVisible && <DeleteRecipeIngredient
          data={propsData}
          isOpen={isDeleteRecipeIngredientVisible} 
          isCancel={() => { setIsDeleteRecipeIngredientVisible(false) }} 
          getRecipeIngredientData={getRecipeIngredientData} 
        />}
      </Modal>
    </>
  )
}

export default RecipeIngredient
